import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=08be5024&"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js&"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports